module.exports = __webpack_public_path__ + "static/media/avatar26.23f8bfdb.png";